import React from "react"

import { Layout, PageContextProvider, DatePickersProvider } from "./components/Layout"
import { MarkdownComponentsProvider } from "./components/Markdown";

import { useSiteMeta } from "./data/SiteMeta";
import { getPageMeta } from "./data/PageMeta";



export default (props: any, ...rest: any) => {
	const { children } = props;
	
	const pageMeta = getPageMeta(props.pageContext);
	const siteMeta = useSiteMeta();

	return (
		<PageContextProvider value={{ pageMeta, siteMeta }}>
			<DatePickersProvider>
				<MarkdownComponentsProvider>
					<Layout>
						{children}
					</Layout>
				</MarkdownComponentsProvider>
			</DatePickersProvider>
		</PageContextProvider>
	);
}
